import React, { memo, useEffect, useMemo, useRef } from "react";
import { LOOKS, LOOK_IDS, gradePixel, lookParams, mergeParams } from "../../video/grade/grade";

// A small picture of the video's current frame in each look. They are drawn by the same sums as the real grade, so they show what the look will do to this very video.
function Thumb({ frame, params, lut }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !frame) return;
    canvas.width = frame.width;
    canvas.height = frame.height;
    const ctx = canvas.getContext("2d");
    const out = ctx.createImageData(frame.width, frame.height);
    const d = frame.data;
    for (let i = 0; i < d.length; i += 4) {
      const g = gradePixel([d[i] / 255, d[i + 1] / 255, d[i + 2] / 255], params, lut);
      out.data[i] = g[0] * 255; out.data[i + 1] = g[1] * 255; out.data[i + 2] = g[2] * 255; out.data[i + 3] = 255;
    }
    ctx.putImageData(out, 0, 0);
  }, [frame, params, lut]);
  return <canvas ref={ref} className="w-full h-auto block rounded-md bg-black" aria-hidden="true" />;
}

function LookGrid({ frame, selected, onPick, lut, lutStrength }) {
  const sets = useMemo(() => ({ none: mergeParams({ lutStrength }), ...Object.fromEntries(LOOK_IDS.map((id) => [id, { ...lookParams(id), lutStrength }])) }), [lutStrength]);
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2.5">
      {[null, ...LOOK_IDS].map((id) => (
        <button key={id || "none"} type="button" onClick={() => onPick(id)} aria-pressed={selected === (id || "")} title={id ? LOOKS[id].about : "No look: the video as it is"}
          className={`text-left rounded-lg p-1 border-2 transition-colors ${selected === (id || "") ? "border-accent-light bg-accent/10" : "border-transparent hover:border-white/30"}`}>
          <Thumb frame={frame} params={id ? sets[id] : sets.none} lut={lut} />
          <span className="block text-[11px] leading-tight text-gray-200 mt-1 px-0.5">{id ? LOOKS[id].label : "Original"}</span>
        </button>
      ))}
    </div>
  );
}

export default memo(LookGrid);        // (the thumbnails are redrawn only when the frame, the table or the choice changes, not at every move of a slider)
